import React from 'react';
import { Input } from '../../ui';

interface ParseJsonConfigProps {
  config: any;
  onChange: (key: string, value: any) => void;
}

export const ParseJsonConfig: React.FC<ParseJsonConfigProps> = ({ config, onChange }) => {
  const onError = String(config.onError || 'fail').toLowerCase() === 'continue' ? 'continue' : 'fail';

  return (
    <div className="space-y-4">
      <div className="bg-blue-50 dark:bg-blue-500/10 border border-blue-200 dark:border-blue-500/30 rounded-lg p-3 text-xs text-blue-700 dark:text-blue-200 leading-relaxed">
        <strong className="text-blue-800 dark:text-blue-100">Como funciona:</strong> Converte um texto JSON em objeto.
        Use a variável de saída com dot notation, por exemplo
        <code className="bg-blue-100 dark:bg-blue-500/30 px-1 rounded text-blue-800 dark:text-blue-100 mx-1">{'{{parsed_json.nome}}'}</code>
        ou ative a opção para expor chaves de topo como variáveis diretas.
      </div>

      <Input
        label="Variável de origem (texto JSON)"
        placeholder="Ex: ai_response ou {{ai_response}}"
        value={config.sourceVariable || ''}
        onChange={(e) => onChange('sourceVariable', e.target.value)}
      />

      <Input
        label="Variável de saída (objeto)"
        placeholder="Ex: parsed_json"
        value={config.outputVariable || ''}
        onChange={(e) => onChange('outputVariable', e.target.value.replace(/\s/g, '_'))}
      />

      <label className="flex items-center gap-2 text-sm text-slate-700 dark:text-slate-200">
        <input
          type="checkbox"
          checked={config.exposeTopLevelFields !== false}
          onChange={(event) => onChange('exposeTopLevelFields', event.target.checked)}
        />
        Expor campos de topo como variáveis
      </label>

      {config.exposeTopLevelFields !== false && (
        <Input
          label="Prefixo das variáveis de topo (opcional)"
          placeholder="Ex: lead_"
          value={config.topLevelPrefix || ''}
          onChange={(e) => onChange('topLevelPrefix', e.target.value.replace(/\s/g, '_'))}
        />
      )}

      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-200 mb-1">
          Se o JSON for inválido
        </label>
        <select
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={onError}
          onChange={(e) => onChange('onError', e.target.value)}
        >
          <option value="fail">Falhar nó</option>
          <option value="continue">Continuar fluxo</option>
        </select>
      </div>

      {onError === 'continue' && (
        <Input
          label="Variável para erro de parse"
          placeholder="Ex: parse_json_error"
          value={config.errorVariable || ''}
          onChange={(e) => onChange('errorVariable', e.target.value.replace(/\s/g, '_'))}
        />
      )}
    </div>
  );
};
